<template>
  <div class="tl">
    <Breadcrumbs main="Рейтинг" title="История рейтинга команды"/>

    <div class="container-fluid tl-container">

      <div class="tl-toolbar">
        <div class="tl-toolbar__main">
          <router-link :to="{ name: 'rating_teams' }" class="tl-icon-btn"
                       v-b-tooltip.hover.bottom="'К рейтингу команд'">
            <i class="fa fa-arrow-left"></i>
          </router-link>

          <div class="tl-search">
            <i class="fa fa-search tl-search__icon"></i>
            <input ref="search"
                   type="search"
                   class="tl-search__input"
                   v-model="searchModel"
                   placeholder="Поиск по ID или названию турнира…"
                   @keydown.esc.prevent="clearSearch"/>
            <button v-if="searchModel" type="button" class="tl-search__clear" @click="clearSearch">
              <i class="fa fa-times"></i>
            </button>
            <kbd v-else class="tl-search__kbd">/</kbd>
          </div>

          <div class="tl-spacer"></div>

          <router-link :to="{ name: 'teams_info', params: { id: $route.params.id } }"
                       class="tl-btn-ghost">
            <i class="fa fa-shield"></i> Карточка команды
          </router-link>
        </div>

        <div class="rt-meta">
          <span>Команда <b>#{{ $route.params.id }}</b></span>
          <span v-if="searchApplied" class="rt-meta__chip">
            Поиск: «{{ searchApplied }}»
            <button type="button" @click="clearSearch"><i class="fa fa-times"></i></button>
          </span>
        </div>
      </div>

      <div class="tl-panel">
        <div v-if="!rows.length" class="tl-empty">
          <div class="tl-empty__art"><i class="fa fa-star-o"></i></div>
          <div class="tl-empty__title">{{ searchApplied ? 'Ничего не нашлось' : 'Начислений нет' }}</div>
          <div class="tl-empty__text">
            {{ searchApplied
              ? 'Поиск работает по ID и названию турнира.'
              : 'Рейтинг за турниры появится здесь после начисления.' }}
          </div>
          <div v-if="searchApplied" class="tl-empty__actions">
            <button type="button" class="tl-btn-ghost" @click="clearSearch">Сбросить поиск</button>
          </div>
        </div>

        <div v-else class="tl-table-wrap">
          <b-table class="tl-table rt-table"
                   responsive
                   hover
                   borderless
                   show-empty
                   :items="rows"
                   :fields="fields">
            <template #cell(name)="{ item }">
              <div class="rt-team">
                <div>
                  <router-link class="rt-team__name"
                               :to="{ name: 'tournament_ratings_info', params: { id: item.id } }">
                    {{ item.name }}
                  </router-link>
                  <span class="rt-team__sub">ID {{ item.id }}</span>
                </div>
              </div>
            </template>

            <!-- было три параллельных столбца-списка: описание, рейтинг и дата
                 приходилось сопоставлять глазами по строкам -->
            <template #cell(accruals)="{ item }">
              <div class="rt-accruals">
                <div v-for="accrual in item.teamRatings" :key="'accrual' + accrual.id" class="rt-accrual">
                  <span class="rt-chip" :class="accrual.is_actual ? 'rt-chip--primary' : 'rt-chip--danger'">
                    {{ formatPoints(accrual.points) }}
                  </span>
                  <span class="rt-accrual__text">{{ accrual.description || 'без описания' }}</span>
                  <span class="rt-accrual__date">{{ formatDateTime(accrual.created_at) }}</span>
                  <span v-if="!accrual.is_actual" class="rt-chip rt-chip--danger">не учитывается</span>
                </div>
              </div>
            </template>

            <template #cell(total)="{ item }">
              <span class="rt-rating">{{ formatPoints(item.sum_points) }}</span>
            </template>
          </b-table>
        </div>

        <div v-if="rows.length" class="tl-foot">
          <div class="tl-foot__info">
            Показано <b>{{ rows.length }}</b> из <b>{{ totalShow || 0 }}</b>
          </div>
          <b-pagination class="tl-pagination my-0"
                        v-model="currentPageShowModel"
                        :total-rows="totalShow"
                        :per-page="perPage"
                        :limit="7"
                        @change="handlePageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {RatingAdapterMixin} from "../../mixins/Rating/RatingAdapterMixin";
import {ModalAdapterMixin} from "@/mixins/modal/ModalAdapterMixin";
import {PaginationHelperMixin} from "@/mixins/Helpers/PaginationHelperMixin";
import lodash from "lodash";

export default {
  name: "TeamsRatingInfo",
  components: {},
  mixins: [RatingAdapterMixin, ModalAdapterMixin, PaginationHelperMixin],
  created() {
    this.recordPageToStorage(this.currentPageShow, this.pageKey)
    this.showTeamRatings({
      pageNumber: this.getCurrentPageNumber(this.pageKey),
      id: this.$route.params.id,
    })
  },
  data() {
    return {
      searchForTeamRatingInfoModel: '',
      pageKey: 'ratingShowPageNumber',
      perPage: 10,
      debouncedSearch: lodash.debounce(function () {
        this.getFilteredTeamsRatingInfo();
      }, 600),
      fields: [
        {key: 'name', label: 'Турнир', sortable: true},
        {key: 'accruals', label: 'Начисления', sortable: false},
        {key: 'total', label: 'Итого', sortable: true, thClass: 'rt-th--num'},
      ],
    };
  },
  computed: {
    rows() {
      return this.teamRatingsShow || [];
    },

    searchApplied() {
      return (this.searchForTeamRatingInfoModel || '').trim();
    },

    searchModel: {
      get() { return this.searchForTeamRatingInfoModel },
      set(value) {
        this.searchForTeamRatingInfoModel = value;
        this.debouncedSearch();
      }
    },

    currentPageShowModel: {
      get() { return Number(this.currentPageShow) || 1 },
      set(value) { this.currentPageShow = value }
    },
  },
  mounted() {
    window.addEventListener('keydown', this.focusSearch);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.focusSearch);
  },
  methods: {
    focusSearch(event) {
      if (event.key !== '/' || ['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) return;
      event.preventDefault();
      if (this.$refs.search) this.$refs.search.focus();
    },

    clearSearch() {
      this.searchForTeamRatingInfoModel = '';
      this.getFilteredTeamsRatingInfo();
    },

    formatPoints(value) {
      const points = Number(value || 0);
      return `${points > 0 ? '+' : ''}${points.toFixed(2)}`;
    },

    formatDateTime(value) {
      if (!value) return '—';
      const date = new Date(String(value).replace(' ', 'T'));
      if (isNaN(date.getTime())) return String(value);
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },

    handlePageChange(pageNumber) {
      this.recordPageToStorage(pageNumber, this.pageKey)
      this.showTeamRatings({
        pageNumber: pageNumber,
        id: this.$route.params.id,
        ...(this.searchForTeamRatingInfoModel && {search: this.searchForTeamRatingInfoModel}),
      })
    },
    getFilteredTeamsRatingInfo() {
      this.showTeamRatings({id: this.$route.params.id, search: this.searchForTeamRatingInfoModel})
    },
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/admin-list.scss";
@import "~@/assets/scss/rating-list.scss";

.tl {
  @include rating-list-parts;

  .rt-accruals {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .rt-accrual {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    &__text {
      font-size: 12.5px;
      color: var(--tl-text);
    }

    &__date {
      font-size: 11.5px;
      color: var(--tl-muted);
      white-space: nowrap;
    }
  }
}
</style>
